import {Injectable} from '@angular/core';

@Injectable()
export class GAService {

    notify(category, action, args, value?, fieldsObject?) {
        var ga = window['ga'];
        try {
            if (fieldsObject == undefined || fieldsObject == null) {
                fieldsObject = {};
            }
            // console.log("Sending GA statistics " + action +" - "+ this.listToString(args))
            ga('send', 'event', category, action, this.listToString(args), value, fieldsObject);
        } catch (error) {
            console.log("GA statistics could not be sent - " + error)
        }
    };

    setDimension(action, dimension, obj){
        var ga = window['ga'];
        ga(action, dimension, obj);
    }

    listToString(args) {
        // returns args as strings concatenation
        return args ? args.join(', ') : 'default_label';
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/root/ga/ga.service.ts